import { CheckedFillIcon, RoundIcon } from "@t8891/icon";
import React from "react";
import { ISuperFrom, switchSupplies } from "@components/InquiryLogistics/SuperForm";
import { InquirySecondInformation, InquirySecondInformationOption } from "@legacy/types/bidding";
import { itemIdValueEqual } from "utils/InquiryLogistics";

interface IRadioItemProps extends ISuperFrom {
  item: InquirySecondInformationOption;
  itemId: InquirySecondInformation["form"]["fields"][0]["itemId"];
}

const RadioItem: React.FC<IRadioItemProps> = ({ item, itemId, formParams, onChange }) => {
  const { label, value } = item;
  return (
    <div
      className='flex gap-8 items-center cursor-pointer'
      onClick={() => {
        onChange({ itemId, ...item, type: "radio" });
      }}
    >
      <div className='flex items-center'>
        {itemIdValueEqual({ formParams, itemId, value }) ? (
          <CheckedFillIcon size={18} fill='#3264FF' />
        ) : (
          <RoundIcon size={18} />
        )}
      </div>
      <div className={`text-14 text-[#333]`}>{label}</div>
    </div>
  );
};

interface ISelectRadio extends ISuperFrom {
  item: InquirySecondInformation["form"]["fields"][0];
  parentItemId: number;
}

const SelectRadio: React.FC<ISelectRadio> = ({ item, formParams, onChange, parentItemId }) => {
  const { label, title, options, required, itemId } = item;

  return (
    <div data-test-id='inquiry-logistics-select'>
      <div className={`${parentItemId === item.itemId ? "text-16 font-[600]" : "text-14"} flex  mb-16`}>
        {!!required && (
          <div className='flex items-center'>
            <div className='text-[#FF0000] text-16 h-10'>*</div>
          </div>
        )}
        {title}
      </div>
      <div className='grid gap-10'>
        {options?.map((vv: InquirySecondInformationOption, index: number) => (
          <div className='grid gap-8 items-center' key={index}>
            <RadioItem item={vv} itemId={itemId} onChange={onChange} formParams={formParams} />
            {vv?.children &&
              itemIdValueEqual({ formParams, itemId, value: vv.value }) &&
              Object.keys(vv?.children).length > 0 &&
              switchSupplies({ item: vv.children, formParams, onChange, parentItemId: itemId })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectRadio;
